'use strict'
import React from 'react'

class PricingHelper {
    static getPriceByBillingMethod(method, currency, currentCurrency, multiCurrencyPricing, defaultPricing) {
        if (currency === currentCurrency) {
            return defaultPricing[method]
        }
        const currencyPricing = multiCurrencyPricing.filter(p => p.currency === currentCurrency)[0]
        if (currencyPricing) {
            switch (method) {
                case 'one-time':
                    return currencyPricing.oneTimePrice
                case 'monthly':
                    return currencyPricing.monthlyPrice
                case 'yearly':
                    return currencyPricing.yearlyPrice
            }
        }
        return '0'
    }

    static setPriceByBillingMethod(price, method, currency, multiCurrencyPricing) {
        let field = 'oneTimePrice'
        switch (method) {
            case 'monthly':
                field = 'monthlyPrice'
                break
            case 'yearly':
                field = 'yearlyPrice'
                break
        }
        let newMultiCurrencyPricing = multiCurrencyPricing
        const currencyPricing = multiCurrencyPricing.filter(p => p.currency === currency)[0]
        if (currencyPricing) {
            newMultiCurrencyPricing = multiCurrencyPricing.map(p => {
                if (p.currency === currency) {
                    p[field] = price
                }
                return p
            })
        } else {
            const pricing = {
                currency: currency,
                oneTimePrice: '0',
                monthlyPrice: '0',
                yearlyPrice: '0',
            }
            pricing[field] = price
            newMultiCurrencyPricing.push(pricing)
        }
        return newMultiCurrencyPricing
    }

}

export default PricingHelper


// WEBPACK FOOTER //
// ./src/product/PricingHelper.jsx